import { getIssuePriority } from 'shared/constants/issues';
import {
  WageColumn,
  IssueTitleColumn,
  EmergencyColumn,
  OrderTimeColumn,
  CompleteTimeColumn,
  ViewColumn,
  FlagColumn,
} from 'views/Wages/commonColumns';

export const getDetailedTableData = (myWageData, selectedOrganizationId) => {
  const myWage = myWageData.filter(
    (item) => item.organization.id === selectedOrganizationId
  );

  const tableData = myWage.map((wage) => {
    const {
      id,
      issueCreatedAt,
      createdAt,
      issueId,
      issueTitle,
      issuePriority,
      originalWage,
      currentWage,
      starred,
    } = wage;

    return {
      issueTitle: issueTitle,
      emergency: getIssuePriority(issuePriority),
      orderTime: issueCreatedAt,
      completeTime: createdAt,
      wage: {
        originalWage: originalWage,
        currentWage: currentWage,
      },
      view: {
        wageId: id,
        issueId: issueId,
      },
      flag: starred,
    };
  });
  return tableData;
};

export const getDetailedTableColumns = (goToIssueDetails) => {
  return [
    IssueTitleColumn(),
    EmergencyColumn(),
    OrderTimeColumn(),
    CompleteTimeColumn(),
    WageColumn(),
    ViewColumn(goToIssueDetails),
    FlagColumn(),
  ];
};
